<template>
  <div id="moto-add" class="sav-wrapper">
    <Topbar/>
		<div class="sav-container">
      <Header back="/new" title="Νέα ασφάλεια μηχανής" category="moto"/>
      <Add category="moto" :id="id" :cardHeaders="motoHeaders" />
    </div>
  </div>
</template>

<script>
import Topbar from './../Topbar.vue'
import Header from './../Header.vue'
import Add from './../Add.vue'
import motoHeaders from './../../../public/data/db.moto-single-headers.json'

export default {
	props: ['id'],
    components: {
    Topbar,
    Header,
    Add
  },
  data() {
        return {
            motoHeaders: motoHeaders
        }
	}
}
</script>

<style lang="scss" scoped>
</style>
